import axios from '@/libs/axios'
import { fetchProductCatalog, submitProductPurchase, fetchMyProductPurchases } from '@/api/productCatalog'

export default {
  namespaced: true,
  state: {
    isLoading: false,
    catalogPrograms: [],     // [{ program, categories: [{ category, products[] }] }]
    myPurchases: [],
    checkoutProduct: null,
    checkoutVisible: false,
    isSubmitting: false,
    lastPurchase: null,
    children: [],
    userCards: [],
    paymentMethod: 'Credit Card',
    paymentFees: [],
    applications: [],
    selectedApplication: null,
  },
  getters: {
    getIsLoading: s => s.isLoading,
    getCatalogPrograms: s => s.catalogPrograms,
    // kept for any legacy references
    getCatalogGroups: s => s.catalogPrograms,
    getMyPurchases: s => s.myPurchases,
    getCheckoutProduct: s => s.checkoutProduct,
    getCheckoutVisible: s => s.checkoutVisible,
    getIsSubmitting: s => s.isSubmitting,
    getLastPurchase: s => s.lastPurchase,
    getChildren: s => s.children,
    getUserCards: s => s.userCards,
    getPaymentMethod: s => s.paymentMethod,
    getPaymentFees: s => s.paymentFees
  },
  mutations: {
    SET_IS_LOADING: (state, val) => { state.isLoading = val },
    SET_CATALOG_PROGRAMS: (state, val) => { state.catalogPrograms = val },
    SET_MY_PURCHASES: (state, val) => { state.myPurchases = val },
    SET_CHECKOUT_PRODUCT: (state, val) => { state.checkoutProduct = val },
    SET_CHECKOUT_VISIBLE: (state, val) => { state.checkoutVisible = val },
    SET_IS_SUBMITTING: (state, val) => { state.isSubmitting = val },
    SET_LAST_PURCHASE: (state, val) => { state.lastPurchase = val },
    SET_CHILDREN: (state, val) => { state.children = val },
    SET_USER_CARDS: (state, val) => { state.userCards = val },
    SET_PAYMENT_METHOD: (state, val) => { state.paymentMethod = val },
    SET_PAYMENT_FEES: (state, val) => { state.paymentFees = val },
  },
  actions: {
    async fetchCatalog({ commit }) {
      commit('SET_IS_LOADING', true)
      try {
        const res = await fetchProductCatalog()
        commit('SET_CATALOG_PROGRAMS', res.data.data || [])
      } catch (e) {
        console.error('Failed to load product catalog', e)
      } finally {
        commit('SET_IS_LOADING', false)
      }
    },

    async fetchMyPurchases({ commit }) {
      try {
        const res = await fetchMyProductPurchases()
        commit('SET_MY_PURCHASES', res.data.data || [])
      } catch (e) {
        console.error('Failed to load purchase history', e)
      }
    },

    /**
     * Fetch payment fees that apply to a given product.
     * Falls back gracefully if the product has no program_id.
     */
    async fetchProductPaymentFees({ commit }, product) {
      if (!product || !product.program_id) {
        commit('SET_PAYMENT_FEES', [])
        return
      }
      try {
        const response = await axios.get('/payment-fees', { params: { program_id: product.program_id } })
        commit('SET_PAYMENT_FEES', response.data.data || [])
      } catch (e) {
        console.error('Failed to load product payment fees', e)
        commit('SET_PAYMENT_FEES', [])
      }
    },

    /**
     * Submit a product purchase.
     * NOTE: the component is responsible for closing the modal / showing a status modal.
     */
    async purchase({ commit, dispatch }, payload) {
      commit('SET_IS_SUBMITTING', true)
      try {
        const res = await submitProductPurchase(payload)
        commit('SET_LAST_PURCHASE', res.data.data)
        await dispatch('fetchMyPurchases')
        return res.data.data
      } finally {
        commit('SET_IS_SUBMITTING', false)
      }
    },

    openCheckout({ commit, dispatch }, product) {
      commit('SET_CHECKOUT_PRODUCT', product)
      commit('SET_LAST_PURCHASE', null)
      commit('SET_PAYMENT_METHOD', 'Credit Card')
      commit('SET_PAYMENT_FEES', [])
      commit('SET_CHECKOUT_VISIBLE', true)
      dispatch('fetchProductPaymentFees', product)
    },

    closeCheckout({ commit }) {
      commit('SET_CHECKOUT_VISIBLE', false)
      commit('SET_CHECKOUT_PRODUCT', null)
      commit('SET_PAYMENT_METHOD', 'Credit Card')
      commit('SET_PAYMENT_FEES', [])
    },
  },
}
